import {
  Box,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Stack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { getFollowingStories, getUserStories } from "../service";
import FollowersStoryCard from "./FollowersStoryCard";
import { SelectTypeOfStory } from "./SelectTypeOfStory";
import StoriesCard from "./StoriesCard";

import Stories from "stories-react";
import "stories-react/dist/index.css";
import T from "./T";
import { photoBaseURL } from "../../../../service/api";
import StoriesSkeleton from "../../../../components/StoriesSkeleton";
import {
  storiesSubstractWidthFromSidebar,
} from "../../../../constants";
import logo from "../../../../assets/logo.svg";
import "./AllStories.css";

function AllStories({ acctType }) {
  const [storiesList, setStoriesList] = useState([]); //followingStories
  const [myStoryList, setMyStoryList] = useState([]);

  const [reload, setReload] = useState({});
  const [viewStory, setViewStory] = useState({ view: false, data: {} });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUserStories(setMyStoryList, setLoading);
    getFollowingStories(setStoriesList, acctType, setLoading);
  }, [acctType, reload]);

  console.log('setStoriesList: ', storiesList);

  useEffect(() => {
    // drag stories to left/right functionality
    const slider = document.querySelector(".items");
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;
    });
  }, []);

  let scrollOverride = `
  .items::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.items {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
 scroll-behavior: smooth;
}
  `;
  let leftSvgIcon = `<svg style="color: #fff;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. --><path d="M256 0C114.6 0 0 114.6 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256C512 114.6 397.4 0 256 0zM310.6 345.4c12.5 12.5 12.5 32.75 0 45.25s-32.75 12.5-45.25 0l-112-112C147.1 272.4 144 264.2 144 256s3.125-16.38 9.375-22.62l112-112c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L221.3 256L310.6 345.4z" fill="#bdbdbd"></path></svg>`;
  let rightSvgIcon = `<svg style="color: rgb(62, 62, 61);" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. --><path d="M256 0C114.6 0 0 114.6 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256C512 114.6 397.4 0 256 0zM358.6 278.6l-112 112c-12.5 12.5-32.75 12.5-45.25 0s-12.5-32.75 0-45.25L290.8 256L201.4 166.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l112 112C364.9 239.6 368 247.8 368 256S364.9 272.4 358.6 278.6z" fill="#bdbdbd"></path></svg>`;

  let leftImgToBase64 = window.btoa(leftSvgIcon);
  let rightImgToBase64 = window.btoa(rightSvgIcon);

  const arrows = `
  .Actions-styles_left__eky50:before{
    content: '';
    background: url(data:image/svg+xml;base64,${leftImgToBase64});
    background-size:cover;
        position:absolute;
    width:30px;
    height:30px;
    top: 50%;
    cursor: pointer;
    left: 30px;
}
.Actions-styles_right__zguoH:before{
    content: '';
    background: url(data:image/svg+xml;base64,${rightImgToBase64});
    background-size:cover;
        position:absolute;
    width:30px;
    height:30px;
    top: 50%;
    cursor: pointer;
    right: 30px;
}
  `;

  const storiesStyles = {
    width: '100%',
    height: '85vh',
    objectFit: 'contain',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundSize: 'cover !important',
    backgroundRepeat: 'no-repeat !important',
    backgroundPosition: 'center !important',
    color: '#fff',
  }

  const storyStyles = {
    width: "400px",
    height: "85vh"
  }
  const zz1 = () => {
    const isUser = viewStory?.isUser;
    
    if (isUser) {
      const r = viewStory?.data?.stories?.map((data) => {
        const text = data?.content?.text;

        let image
        switch (data?.type) {
          case "text":
            image = data?.content?.background;
            break;

          case "image":
            image = data?.content?.file;
            break;

          case "video":
            image = `${data?.content}`;
            break;

          default:
            break;
        }

        return {
          type: "component",
          duration: 9000,
          typeOfContent: data?.type,
          image,
          text,

          component: T,
          style: {
            height: "100% !important", // Set the height to 100%
            backgroundPosition: "center !important",
            backgroundSize: "cover !important"
          },
        };
      });
      return r;
    } else {
      const r = viewStory?.data?.stories?.map((data) => {
        const text = data?.content?.text;
        const bg =
          data?.content?.background ||
          `url(${data?.content?.file})`;
        return {
          type: "component",
          duration: 9000,
          typeOfContent: data?.type,
          bg,
          text,

          component: T,
          style: {
            height: "100% !important", // Set the height to 100%
          },
        };
      });

      return r;
    }
  };
const zz = () => {
  const isUser = viewStory?.isUser;

  if (isUser) {
    const r = viewStory?.data?.stories?.map((data) => {
      const text = data?.content?.text;
      let image; let bg;
      switch (data?.type) {
        case "text":
          bg = data?.content?.background;
          break;
        case "image":
          image = data?.content?.file; // Use 'file' for the image URL
          break;
        case "video":
          image = `${data?.content}`;
          break;
        default:
          break;
      }

      if (data?.type === "text") {
        // For text stories, set the type explicitly
        return {
          type: "component",
          duration: 9000,
          typeOfContent: data?.type, // Use the 'type' variable
          bg,
          text,
          component: T,
          style: {
            height: "100%", // Set the height to 100%
            backgroundSize: "cover", // Cover the entire modal
            backgroundPosition: "center", // Center the background image
          },
        };
      }

      // For 'image' type stories, use the Chakra UI 'Image' component
      if (data?.type === "image") {
        return {
          type: "component",
          duration: 9000,
          typeOfContent: data?.type,
          component: () => (
            <Image
              src={image} // Set the 'src' attribute for the Image component
              alt="Story Image"
              width="100%" // Set the width to 100%
              height="100%" // Set the height to 100%
              objectFit="cover" // Cover the entire modal
            />
          ),
        };
      }

      return {
        type: "component",
        duration: 9000,
        typeOfContent: data?.type,
        image, // Use 'image' instead of 'bg'
        text,
        component: T,
        style: {
          height: "100%", // Set the height to 100%
          backgroundSize: "cover", // Cover the entire modal
          backgroundPosition: "center", // Center the background image
        },
      };
    });
    return r;
  } else {
    const r = viewStory?.data?.stories?.map((data) => {
      const text = data?.content?.text;
      let image; let bg
      switch (data?.type) {
        case "text":
          image = data?.content?.background;
          break;
        case "image":
          image = data?.content?.file; // Use 'file' for the image URL
          break;
        case "video":
          image = `${data?.content}`;
          break;
        default:
          break;
      }

      if (data?.type === "text") {
        // For text stories, set the type explicitly
        return {
          type: "component",
          duration: 9000,
          typeOfContent: data?.type, // Use the 'type' variable
          image,
          text,
          component: T,
          style: {
            height: "100%", // Set the height to 100%
            backgroundSize: "cover", // Cover the entire modal
            backgroundPosition: "center", // Center the background image
          },
        };
      }

      // For 'image' type stories, use the Chakra UI 'Image' component
      if (data?.type === "image") {
        return {
          type: "component",
          duration: 9000,
          typeOfContent: data?.type,
          component: () => (
            <Image
              src={image} // Set the 'src' attribute for the Image component
              alt="Story Image"
              width="100%" // Set the width to 100%
              height="100%" // Set the height to 100%
              objectFit="cover" // Cover the entire modal
            />
          ),
        };
      }

      return {
        type: "component",
        duration: 9000,
        typeOfContent: data?.type,
        image, // Use 'image' instead of 'bg'
        text,
        component: T,

      };
    });

    return r;
  }
};


  return (
    <Flex mb="20px" alignItems={"flex-start"}>
      <Box mr="30px">
        <SelectTypeOfStory acctType={acctType} reload={() => setReload({})} />
      </Box>
      <style>{arrows}</style>
      <style>{scrollOverride}</style>
      <Stack
        direction="row"
        overflow={"scroll"}
        maxW={storiesSubstractWidthFromSidebar}
        w={storiesSubstractWidthFromSidebar}
        className="items"
        spacing={"30px"}
      >
        {loading ? (
          
          <StoriesSkeleton />
        ) : (
          <>
       
            <Box
              cursor={"pointer"}
              onClick={() =>
                setViewStory({
                  view: true,
                  data: myStoryList,
                  isUser: true,
                })
              }
            >
              <StoriesCard story={myStoryList} />
            </Box>
            {storiesList?.data?.map((story) => {
              return (
                <Box
                  cursor={"pointer"}
                  onClick={() => setViewStory({ view: true, data: story })}
                >
                  <FollowersStoryCard story={story} />
                </Box>
              );
            })}
          </>
        )}
      </Stack>
      <Modal
        isOpen={viewStory?.view}
        onClose={() => setViewStory((prev) => ({ ...prev, view: false }))}
      >
        <ModalOverlay />
        <ModalContent bg="none" border="none" boxShadow={"none"}>
          <ModalBody
          >
            {<Stories stories={zz()} width="400px" height="85vh" />}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Flex>
  );
}

export default AllStories;
